(function () {
  var LETTER_ALL = 'ALL';
  var LETTER_NUMERIC = '0-9';
  var DEBOUNCE_MS = 180;

  var root = document.querySelector('[data-lexikon-index]');
  if (!root) {
    return;
  }

  var searchInput = root.querySelector('[data-lexikon-search]');
  var letterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-lexikon-letter]'));
  var letterCountNodes = Array.prototype.slice.call(root.querySelectorAll('[data-lexikon-letter-count]'));
  var listNode = root.querySelector('[data-lexikon-list]');
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-lexikon-item]'));
  var emptyNode = root.querySelector('[data-lexikon-empty]');
  var visibleCountNode = root.querySelector('[data-lexikon-visible-count]');
  var activeLetter = LETTER_ALL;
  var debounceTimer = null;
  var allPagesLoaded = false;

  function normalizeLetter(value) {
    var letter = (value || '').toString().trim().toUpperCase();
    if (!letter) {
      return '';
    }
    if (/^[0-9]/.test(letter)) {
      return LETTER_NUMERIC;
    }
    if (letter === 'Ä') {
      return 'A';
    }
    if (letter === 'Ö') {
      return 'O';
    }
    if (letter === 'Ü') {
      return 'U';
    }
    if (letter === 'ẞ' || letter === 'SS') {
      return 'S';
    }
    return letter.charAt(0);
  }

  function normalize(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function renderLetterCounts(counts) {
    letterCountNodes.forEach(function (node) {
      var key = node.getAttribute('data-lexikon-letter-count');
      node.textContent = ' (' + (counts[key] || 0) + ')';
    });
  }

  function updateUrlState(query, letter) {
    if (!window.history || !window.history.replaceState) {
      return;
    }
    var params = new URLSearchParams(window.location.search);
    var nextQuery = (query || '').toString().trim();
    if (nextQuery) {
      params.set('q', nextQuery);
    } else {
      params.delete('q');
    }

    if (letter && letter !== LETTER_ALL) {
      params.set('letter', letter);
    } else {
      params.delete('letter');
    }
    var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', next);
  }

  function applyFilters() {
    var queryRaw = searchInput ? searchInput.value : '';
    var query = normalize(queryRaw);
    var visible = 0;
    var counts = {};
    counts[LETTER_ALL] = 0;
    counts[LETTER_NUMERIC] = 0;
    for (var code = 65; code <= 90; code += 1) {
      counts[String.fromCharCode(code)] = 0;
    }

    items.forEach(function (item) {
      var haystack = normalize(item.getAttribute('data-search'));
      var itemLetter = normalizeLetter(item.getAttribute('data-letter')) || LETTER_ALL;
      var matchQuery = !query || haystack.indexOf(query) !== -1;
      if (matchQuery) {
        counts[LETTER_ALL] += 1;
        if (itemLetter !== LETTER_ALL && typeof counts[itemLetter] === 'number') {
          counts[itemLetter] += 1;
        }
      }
      var matchLetter = activeLetter === LETTER_ALL || activeLetter === itemLetter;
      var show = matchQuery && matchLetter;

      item.classList.toggle('is-hidden', !show);
      if (show) {
        visible += 1;
      }
    });
    renderLetterCounts(counts);

    if (visibleCountNode) {
      visibleCountNode.textContent = visible;
    }

    if (emptyNode) {
      emptyNode.classList.toggle('is-hidden', visible !== 0);
    }

    updateUrlState(queryRaw, activeLetter);
  }

  function debouncedApplyFilters() {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    debounceTimer = setTimeout(applyFilters, DEBOUNCE_MS);
  }

  function setActiveLetter(nextLetter) {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
      debounceTimer = null;
    }
    activeLetter = nextLetter;
    letterButtons.forEach(function (button) {
      var isActive = button.getAttribute('data-lexikon-letter') === nextLetter;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    applyFilters();
  }

  /* Arrow-key navigation for letter toolbar (WAI-ARIA toolbar pattern:
     arrows move focus, Enter/Space activates) */
  function moveFocusToButton(idx) {
    letterButtons.forEach(function (button, i) {
      button.setAttribute('tabindex', i === idx ? '0' : '-1');
    });
    letterButtons[idx].focus();
  }

  function handleLetterKeydown(event) {
    var idx = letterButtons.indexOf(event.target);
    if (idx === -1) return;

    var next = -1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      next = (idx + 1) % letterButtons.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      next = (idx - 1 + letterButtons.length) % letterButtons.length;
    } else if (event.key === 'Home') {
      next = 0;
    } else if (event.key === 'End') {
      next = letterButtons.length - 1;
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      setActiveLetter(event.target.getAttribute('data-lexikon-letter') || LETTER_ALL);
      return;
    }

    if (next !== -1) {
      event.preventDefault();
      moveFocusToButton(next);
    }
  }

  letterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setActiveLetter(button.getAttribute('data-lexikon-letter') || LETTER_ALL);
    });
    button.addEventListener('keydown', handleLetterKeydown);
  });

  if (searchInput) {
    searchInput.addEventListener('input', debouncedApplyFilters);
  }

  var params = new URLSearchParams(window.location.search);
  var letterParam = (params.get('letter') || LETTER_ALL).toUpperCase();
  var queryParam = params.get('q') || '';

  if (searchInput && queryParam) {
    searchInput.value = queryParam;
  }

  var hasRequestedLetter = letterButtons.some(function (button) {
    return button.getAttribute('data-lexikon-letter') === letterParam;
  });
  if (hasRequestedLetter) {
    activeLetter = letterParam;
  }

  setActiveLetter(activeLetter);

  /* ── AJAX loader: fetch ALL remaining paginated pages so every entry
       is available for client-side search & filter. ──
     Uses data-total-entries / data-per-page / data-current-page attributes
     from the section element to calculate the total number of pages.
     Pages are fetched sequentially to avoid Shopify rate-limiting.
     Items appear progressively as each page loads. */
  function loadRemainingPages() {
    if (allPagesLoaded) return;
    allPagesLoaded = true;

    var totalEntries = parseInt(root.getAttribute('data-total-entries') || '0', 10);
    var perPage = parseInt(root.getAttribute('data-per-page') || '50', 10);
    var currentPage = parseInt(root.getAttribute('data-current-page') || '1', 10);
    var maxPage = Math.ceil(totalEntries / perPage);

    if (maxPage <= 1) return;

    var pagesToFetch = [];
    for (var p = 1; p <= maxPage; p++) {
      if (p !== currentPage) pagesToFetch.push(p);
    }
    if (!pagesToFetch.length) return;

    var basePath = window.location.pathname;

    /* Track items by handle to avoid duplicates (more reliable than data-search) */
    var existingHandles = {};
    items.forEach(function (item) {
      var link = item.querySelector('.jm-lexikon-index__item-title a');
      var href = link ? link.getAttribute('href') : '';
      if (href) existingHandles[href] = true;
    });

    /* Fetch a single page with retry logic and cache-busting */
    function fetchPage(url, retries) {
      var cacheBuster = url + (url.indexOf('?') !== -1 ? '&' : '?') + '_v=' + Date.now();
      return fetch(cacheBuster, { cache: 'no-store' }).then(function (res) {
        if (!res.ok) {
          throw new Error('HTTP ' + res.status);
        }
        return res.text();
      }).catch(function (err) {
        if (retries > 0) {
          var delay = (4 - retries) * 500; /* 500ms, 1000ms, 1500ms */
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(fetchPage(url, retries - 1));
            }, delay);
          });
        }
        console.warn('[Lexikon] Failed to fetch ' + url + ':', err.message);
        return null;
      });
    }

    /* Parse items from fetched HTML */
    function extractItems(html) {
      if (!html) return [];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.prototype.slice.call(doc.querySelectorAll('[data-lexikon-item]'));
    }

    /* Merge new items into the list and re-apply filters */
    function mergeItems(newItems, beforeCurrent) {
      if (!newItems.length || !listNode) return;

      var added = 0;
      if (beforeCurrent) {
        var firstCurrentItem = listNode.firstElementChild;
        newItems.forEach(function (item) {
          var link = item.querySelector('.jm-lexikon-index__item-title a');
          var href = link ? link.getAttribute('href') : '';
          if (href && existingHandles[href]) return;
          if (href) existingHandles[href] = true;
          item.classList.add('is-hidden');
          listNode.insertBefore(item, firstCurrentItem);
          items.push(item);
          added++;
        });
      } else {
        var fragment = document.createDocumentFragment();
        newItems.forEach(function (item) {
          var link = item.querySelector('.jm-lexikon-index__item-title a');
          var href = link ? link.getAttribute('href') : '';
          if (href && existingHandles[href]) return;
          if (href) existingHandles[href] = true;
          item.classList.add('is-hidden');
          fragment.appendChild(item);
          items.push(item);
          added++;
        });
        listNode.appendChild(fragment);
      }

      if (added > 0) applyFilters();
    }

    /* Fetch pages sequentially: first pages before current, then after */
    var beforePages = pagesToFetch.filter(function (p) { return p < currentPage; });
    var afterPages = pagesToFetch.filter(function (p) { return p > currentPage; });
    /* Process pages closest to current first for better UX */
    beforePages.reverse();

    var allPages = beforePages.concat(afterPages);
    var pageIndex = 0;

    function fetchNext() {
      if (pageIndex >= allPages.length) {
        onAllPagesLoaded();
        return;
      }

      var pageNum = allPages[pageIndex];
      var isBefore = pageNum < currentPage;
      pageIndex++;

      fetchPage(basePath + '?page=' + pageNum, 3).then(function (html) {
        var newItems = extractItems(html);
        mergeItems(newItems, isBefore);
        fetchNext();
      });
    }

    function onAllPagesLoaded() {
      /* Hide pagination nav */
      var paginationNav = root.querySelector('.jm-lexikon-index__pagination');
      if (paginationNav) paginationNav.style.display = 'none';

      /* Update the "von X Begriffen" counter */
      var counterNode = root.querySelector('[data-lexikon-meta-counter]');
      if (counterNode) {
        var totalNow = items.length;
        counterNode.innerHTML =
          '<span class="jm-lexikon-index__meta-count" data-lexikon-visible-count>' + totalNow + '</span>' +
          ' von ' + totalNow + ' Begriffen sichtbar';
        visibleCountNode = root.querySelector('[data-lexikon-visible-count]');
      }

      /* Hide the "Hinweis" notice */
      var hinweisNode = root.querySelector('[data-lexikon-meta-hinweis]');
      if (hinweisNode) hinweisNode.style.display = 'none';

      /* Clean up the page= param from URL */
      if (window.history && window.history.replaceState) {
        var cleanParams = new URLSearchParams(window.location.search);
        cleanParams.delete('page');
        var cleanUrl = window.location.pathname + (cleanParams.toString() ? '?' + cleanParams.toString() : '');
        window.history.replaceState({}, '', cleanUrl);
      }

      applyFilters();
    }

    fetchNext();
  }

  /* Start loading remaining pages immediately (non-blocking) */
  loadRemainingPages();
})();
